import ApiConstants from "../../constants/ApiConstant";
import httpClient from "../index";
export const uploadFileToS3 = (blob: Blob) => {
    const formData = new FormData()
    formData.append("file", blob)
    formData.append("file-entity", "REPORT_THUMBNAIL")
    return httpClient.post(ApiConstants.REPORT.FILE_UPLOAD, formData);
}